// src/AppRouter.jsx
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/auth/Login';
import Setpassword from './components/auth/SetPassword';
import Signup from './components/auth/Signup';
import ConfirmEmail from './components/auth/ConfirmEmail';
import ForgotPassword from './components/auth/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword';
import Layout from './components/layouts/Layout';
import PBConversion from './components/pages/PBConversion';

import PrivateRoute from './PrivateRoute';

function AppRouter({ token }) {
  return (
    <Router>
      <Routes>
         <Route path="/" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/set-password" element={<Setpassword token={token} />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/resetpassword" element={<ResetPassword token={token} />} />
        <Route path="/confirmemail" element={<ConfirmEmail token={token} />} />
        <Route
          element={
           <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route path="/pb-conversion" element={<PBConversion />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default AppRouter;
